var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('el-container',[_c('el-menu',{staticClass:"el-menu-vertical-demo index",attrs:{"default-active":_vm.activepath,"background-color":"#304156","text-color":"#fff","active-text-color":"#ffd04b","router":"","collapse":_vm.sidebarWidth}},[_c('sidebarList',{attrs:{"menu":_vm.menu}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }